// styles.js
export const commonStyles = {
    mainModal: {
        top: 0,
        right: 0,
        margin: "0px",
        borderRadius: "8px 8px 8px 8px",
        minHeight:"60vh",
        zIndex: 9999,
        color: "000000",
        fontSize: "24px",
      },
      avatarStyle:{ backgroundColor: "#E0F7FA", color: "#007D87" },
  };
  